// extracted by mini-css-extract-plugin
module.exports = {"container":"CampaignList_container__1UCRl"};